module.exports = __webpack_public_path__ + "img/portfolio--agency-02.db079e80.jpg";